import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@fluentui/react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { getRouterDep } from '@bingads-webui-campaign-react/legacy-router-dep';

export const BMCRedirect = ({
  isEnabledForDynamicFeedCampaign,
  i18n,
  scope,
  activity,
}) => {
  const toBMC = useCallback(() => {
    getRouterDep(scope).navigateToRoute('bing_merchant_center');
  }, [scope]);

  const toDynamicDataManagement = useCallback(() => {
    getRouterDep(scope).navigateToRoute('dynamicdata_management');
  }, [scope]);

  useEffect(() => {
    activity.signal('RenderBMCRedirect');
  }, []);

  return (
    <div>
      <ReactTemplate
        model={{
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          a: text => <Link aria-label={text} onClick={toBMC}>{text}</Link>,
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          b: text => (isEnabledForDynamicFeedCampaign ? <> or <Link aria-label={text} onClick={toDynamicDataManagement}>{text}</Link></> : null),
        }}
        template={i18n.getString(_TL_('To create a shopping campaign, you need to create a Microsoft Merchant Center store and add your catalog. {{a}}Create a store{{/a}} {{b}}Upload a Dynamic Data Feed{{/b}}'))}
      />
    </div>
  );
};

BMCRedirect.propTypes = {
  isEnabledForDynamicFeedCampaign: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  scope: PropTypes.string.isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func.isRequired,
  }).isRequired,
};
